import React, {useEffect, useState, useCallback} from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { getJudgeName } from "../../utils";

const Phase6 = (props) => {
  const handleSetStale = props.handleSetStale
  const handleUpdatePhotoCard = props.handleUpdatePhotoCard
  const handleCaptionCreate = props.handleCaptionCreate
  const handleCaptionSelected = props.handleCaptionSelected
  const handleGameStateChanged = props.handleGameStateChanged

  const [error, setError] = useState('');
  const [captionSubmitted, setCaptionSubmitted] = useState(false);
  const [hasWaited, setHasWaited] = useState(false);
  const [photoCard, setPhotoCard] = useState({});
  const [countdownSecond, setCountdownSecond] = useState(4);
  const [leaderboardCountdown, setLeaderboardCountdown] = useState(60);
  const isMobile = useIsMobile();

  const getPhotoCard = (photoCardId) => {
    for (let i = 0; i < props.photoCards.length; i++) {
      if (props.photoCards[i]["$id"] === photoCardId) {
        return props.photoCards[i]
      }
    }
  }

  useEffect(() => {
    if (props.gameState?.PhotoCardID === "" || props.gameState?.PhotoCardID === undefined || props.gameState?.PhotoCardID === null) {
      return
    }
    setPhotoCard(getPhotoCard(props.gameState.PhotoCardID))
    const timer = setTimeout(() => {
      setCountdownSecond(countdownSecond - 1);
      if (countdownSecond <= 1) {
        setHasWaited(true)
        clearTimeout(timer)
      }
    }, 1000);

    if (hasWaited) {
      const leaderboardTimer = setTimeout(() => {
        setLeaderboardCountdown(leaderboardCountdown - 1);
        if (leaderboardCountdown <= 1) {
          handleGameStateChanged({newPhase: 7})
          clearTimeout(leaderboardTimer)
        }
      }, 1000);
    }

  }, [countdownSecond, props.gameState]);

  const loadJudgeName = useCallback(() => {
    return (
      <div className="p-[5%]">
        <h1 className="text-4xl font-bold text-center text-black">{getJudgeName(props.gameState.JudgeID, props.gameState, props.gameParticipants)}</h1>
      </div>
    )
  }, [props.gameState, props.gameParticipants]);

  const loadPhotoCardPlayer = useCallback(() => {
    return (
      <div className="mt-[5%] text-2xl text-blue-500">
        { hasWaited && "-" + photoCard?.ChosenCaptionPlayer + "-" }
      </div>
    )
  }, [photoCard, hasWaited]);

  const loadRoundWinner = useCallback(() => {
    if (props.gameState?.PhotoCardID === "" || props.gameState?.PhotoCardID === undefined || props.gameState?.PhotoCardID === null) {
      return (
        <div
          className="w-screen h-screen fixed top-0 left-0 bg-gray-900 opacity-75
          bg-[url('https://media.giphy.com/media/8agqybiK5LW8qrG3vJ/giphy.gif')] bg-center bg-no-repeat z-10">
        </div>
      )
    } else {
      return (
        <div className="justify-center content-center">
          <div className="text-gray-950 text-xl">Selected the caption by <span className="font-bold text-2xl">{photoCard?.ChosenCaptionPlayer}</span></div>
          <div className="mt-4 mx-8 content-center text-gray-950 text-xl">{photoCard?.ChosenCaptionPlayer} earns <span className="font-bold text-2xl">{props.gameState?.AwardedPointsPerWin || 100}</span> points</div>
        </div>
      )
    }
  }, [photoCard, props.gameState?.AwardedPointsPerWin]);

  return (
    <>
      <div className="mt-[10%] mx-4 border border-black rounded-xl grid place-items-center">
        {loadJudgeName()}
        <div className="mt-[8px] mb-[10px]">
          { !hasWaited &&
            <h3 className="text-gray-950 text-xl">Selected caption in <span className="font-bold text-xl">{countdownSecond}</span>....</h3>}
          { hasWaited && loadRoundWinner() }
        </div>
        { hasWaited && leaderboardCountdown > 0 &&
          <h3 className="mt-5 text-gray-950 text-xl">Leaderboard in <span className="font-bold text-xl">{leaderboardCountdown}</span> seconds</h3>}
      </div>

      <div className="mt-4">
        <div className="text-xl text-red-900">{error}</div>

        {isMobile ? (

          <div className="flex flex-col justify-center items-center">
            <div className="flex box w-[75%] bg-[#020223] border border-[15px] border-gray-400 rounded-2xl">
              <img src={photoCard?.ImageUrl} />
            </div>

            <div className="mx-12 my-6 flex flex-col items-center">
              <div className="relative w-full text-4xl font-bold">
                { hasWaited && photoCard?.ChosenCaption }
              </div>

              <div className="mt-[5%] text-2xl text-blue-500">
                { hasWaited && "-" + photoCard?.ChosenCaptionPlayer + "-" }
              </div>
            </div>
          </div>

        ) : (

          <div className="flex justify-center items-center">
            <div className="box w-[55%] ml-4 mr-2 h-auto bg-[#020223] border border-[15px] border-gray-400 rounded-2xl">
              <img src={photoCard?.ImageUrl} />
            </div>

            <div className="mx-12 w-[45%] flex flex-col items-center">
              <div className="relative w-full text-4xl font-bold">
                { hasWaited && photoCard?.ChosenCaption }
              </div>

              {loadPhotoCardPlayer()}
            </div>
          </div>
          )}

      </div>
    </>
  )
}

export default Phase6;
